import React, { Component } from 'react';
import { Table,Tabs,Button,Pagination,Input, Row, Col,Select,Modal,Form,message, Breadcrumb,Tag} from 'antd';
import { connect } from 'react-redux';
import '@/css/question_package.less'


import {getAllQuestionTempListAPI,modifyTempStatusAPI,getTempUserListAPI} from '@/API'
import {tableColumns,statusList,questionTypeList} from './constData'




const Search = Input.Search,
	  Option = Select.Option,
	  confirm = Modal.confirm,
	  FormItem = Form.Item;



export  class QuestionTempList extends Component{
	static contextTypes={
	    router: React.PropTypes.object.isRequired,
	    dispatch: React.PropTypes.func.isRequired
	}
	
	constructor(props) {
	    super(props);
	    this.state={
	       listQuery:{
	       		create_user:undefined,
	       		search:'',//查询关键字
	       		stage:'-1',//状态0-停用状态1-使用状态
	       		type_show:'-1',
	       		page:1,
	       		pagesize:10,
	       },
	       list:[],
	       total:0,
	       loading:false,
	       selectedRowKeys:[],
	       tempUserList:[],
	    }

    }
   

    componentDidMount(){
    		this.getAllQuestionTempList()
        this.getTempUserList()
    }

    handleFilterChange(value,type){
    		let listQuery=this.state.listQuery
    		listQuery[type]=value
    		this.setState({listQuery})
    }

    getAllQuestionTempList=()=>{
    		this.setState({
    			loading:true,
    			list:[],
    			selectedRowKeys:[],
    		})
    		getAllQuestionTempListAPI(this.state.listQuery).then(res=>{
    				let data=res.data
    				this.setState({
    					list:data.list,
    					total:~~data.total,
    					loading:false
    				})
    				
    		}).catch(e=>{
    			this.setState({
	    			loading:false
	    		})
    		})
    }
    getTempUserList(){
    		getTempUserListAPI().then(res=>{
    			this.setState({tempUserList:res.data})
    		})
    }
    handleSearch=()=>{
    		this.getAllQuestionTempList()
    }
    handleReset=()=>{
    		let listQuery={
       		create_user:undefined,
       		search:'',//查询关键字
       		stage:'-1',//状态0-停用状态1-使用状态
       		type_show:'-1',
       		page:1,
       		pagesize:10,
       }
    	   this.setState({listQuery},()=>{
    	   		this.getAllQuestionTempList()
    	   })
    	   
    }

    renderFilter(){
    		const formItemLayout = {
	      labelCol: { span: 10 },
	      wrapperCol: { span: 12 },
	    };
	   let userOptions=this.state.tempUserList.map(v=>{return(<Option value={v.id}  key={v.id}>{v.username}</Option>)}),
	   	   statusOptions=statusList.map(v=>{return(<Option value={v.value}  key={v.value}>{v.label}</Option>)}),
	   	   questionTypeOptions=questionTypeList.map(v=>{return(<Option value={v.value}  key={v.value}>{v.label}</Option>)})
	   
    		return(
    			 <Form>
		        <Row >
		        		<Col  span={5}> 
		       			<FormItem {...formItemLayout} label="创建人">
		       			<Select
		       				showSearch
					        value={this.state.listQuery.create_user}
					        defaultActiveFirstOption={false}
					        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
					        onChange={(value)=>this.handleFilterChange(value,'create_user')}
					      >
		       				{userOptions}
		       			 </Select>
		       			</FormItem>
					 </Col>
					<Col  span={5}> 
		       			<FormItem {...formItemLayout} label="状态">
		       			<Select
					        value={this.state.listQuery.stage}
					        onChange={(value)=>this.handleFilterChange(value,'stage')}
					      >
		       				{statusOptions}
		       			 </Select>
		       			</FormItem>
					 </Col>
					<Col  span={5}> 
		       			<FormItem {...formItemLayout} label="题型">
		       			<Select
					        value={this.state.listQuery.type_show}
					        onChange={(value)=>this.handleFilterChange(value,'type_show')}
					      >
		       				{questionTypeOptions}
		       			 </Select>
		       			</FormItem>
					 </Col>
		        		<Col span={5}> 
		        		<FormItem {...formItemLayout} label="模板ID/模板名">
			        		<Input
			        			value={this.state.listQuery.search}
						    onChange={e =>this.handleFilterChange(e.target.value,'search')}
						  />
		        		</FormItem>
		        		</Col>
		        		 <Col span={4} style={{ textAlign: 'right' }}>
			            <Button type="primary" onClick={this.handleSearch}>查询</Button>
			            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>清空</Button>
			         </Col>
		        </Row>
		      </Form>
    		)
    }

    onPageChange=(val)=>{
    		let {listQuery}=this.state
    		listQuery.page=val
    		this.setState({listQuery})
    		this.getAllQuestionTempList()
    }


		
    //各修改状态操作 使用、停用、删除
    handleConfirmModifyStatus(modifyType){
    		let messageMapList={
    			able:'确认【使用】选中模板吗？',
    			disable:'确认【停用】选中模板吗？',
    			delete:'确认【删除】选中模板吗？'
    		}
    		let self=this
    		confirm({
		    title: messageMapList[modifyType],
		    onOk() {
		      	self.modifyTempStatus(modifyType)
		    }
		  });
    		
    }
    modifyTempStatus(modifyType){
    		let params={temp_id:this.state.selectedRowKeys}
    		modifyTempStatusAPI(modifyType,params).then(res=>{
    			message.success('操作成功！')
    			this.getAllQuestionTempList()
    		})
    }


    
    onSelectChange = (selectedRowKeys) => {
	    this.setState({ selectedRowKeys });
	}
	renderBtns(){
		let {selectedRowKeys}=this.state
		const hasSelected = selectedRowKeys.length > 0;
		return(
			<div >
				<div style={{display:'inline-block',width:'50%'}}>
					<Button className="tabFuncBtn" ><a href="/#/questionTML" target="_blank">创建模板</a></Button>
					<Button  disabled={!hasSelected} className="tabFuncBtn" onClick={()=>this.handleConfirmModifyStatus('able')}>使用模板</Button>
					<Button  disabled={!hasSelected} className="tabFuncBtn" onClick={()=>this.handleConfirmModifyStatus('disable')}>停用模板</Button>
					<Button  disabled={!hasSelected} className="tabFuncBtn" onClick={()=>this.handleConfirmModifyStatus('delete')}>删除</Button>
					{hasSelected&&<span style={{ marginLeft: 8,fontSize:'12px' }}>
			            <Tag color="orange">已勾选{selectedRowKeys.length}条</Tag>
			        </span>}
				</div>
			</div>
		)
		
	}
	
	renderTable(){
		let columns=tableColumns

		let {selectedRowKeys,list}=this.state
		const rowSelection = {
	      selectedRowKeys,
	      onChange: this.onSelectChange,
	    };

		return(
			<Table scroll={{ x: true }} rowSelection={rowSelection} loading={this.state.loading} rowKey={record=>record.temp_id} pagination={false} columns={columns} dataSource={list} />
		)
	}
    render(){
		let {total,selectedRowKeys}=this.state

			return(
	            <div >
	                <Breadcrumb className="breadCrumb">
	                    <Breadcrumb.Item  className="breadItem" ><span>题目管理</span></Breadcrumb.Item>
	                    <Breadcrumb.Item className="breadItem"><span>题型模板</span></Breadcrumb.Item> 
	                </Breadcrumb>  
	                 <div>
	                 	{this.renderFilter()}
	                 	{this.renderBtns()}
	                 	{this.renderTable()}
	                 	<div style={{textAlign:'right',margin:'20px'}}><Pagination showQuickJumper defaultCurrent={1} total={total} onChange={this.onPageChange} /></div>
	                 </div>
	            </div>
	       );
    }

}

const mapStateToProps = (state) => {
    return {    
        user:state.user,
    };
}

export default connect(mapStateToProps)(QuestionTempList);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/question_temp_list.js